/**
 * Druid specific Utility module. Contains common druid related tasks.
 */
'use strict';

var $d = require('../dependency');
var moment = $d.moment;
var _ = $d._;

exports.findGranularityFromDays = findGranularityFromDays;
exports.findInterval = findInterval;
exports.findCustomGranularity = findCustomGranularity;
exports.findCustomInterval = findCustomInterval;
exports.getAverageDivisor = getAverageDivisor;
exports.generateAllMinorIntervals = generateAllMinorIntervals;
exports.generateGETQueryString = generateGETQueryString;
exports.zeroFillEmptyBuckets = zeroFillEmptyBuckets;


function findCustomGranularity(duration, customDateObj, override) {
    var startDate = customDateObj.value.customStartDate;
    var endDate = customDateObj.value.customEndDate || customDateObj.value.customPointInTime;
    var numberOfDays;
    var granularity = 'day';

    if (override) {
        granularity = 'all';
    } else {
        startDate = startDate ? moment(startDate).utc().startOf('day') : null;
        endDate = moment(endDate).utc().endOf('day');

        if (startDate && endDate) {
            numberOfDays = moment(endDate).diff(moment(startDate), 'days') + 1;
        } else {
            granularity = 'day';
        }

        if (!_.isNumber(numberOfDays)) {
            granularity = 'day';
        } else if (numberOfDays > 1 && numberOfDays <= 31) {
            granularity = 'day';
        } else if (numberOfDays > 31 && numberOfDays <= 154) {
            granularity = {};
            granularity.type = 'period';
            granularity.period = 'P1W';
        } else if (numberOfDays > 154) {
            granularity = {};
            granularity.type = 'period';
            granularity.period = 'P1M';
        }
    }

    return granularity;
}

function findCustomInterval(duration, customDateObj, granularity) {

    var startDate = customDateObj.value.customStartDate ? customDateObj.value.customStartDate.toISOString() : null;
    var endDate = (customDateObj.value.customEndDate || customDateObj.value.customPointInTime).toISOString();


    if (granularity.type === 'period' && granularity.period === "P1W") {
        endDate = moment(endDate).utc().endOf('isoWeek').subtract(1, 'second');
        startDate = moment(startDate).utc().startOf('isoWeek');
    } else if (granularity.type === 'period' && granularity.period === "P1M") {
        endDate = moment(endDate).utc().endOf('month').subtract(1, 'second');
        startDate = moment(startDate).utc().startOf('month');
    } else {
        endDate = moment(endDate).utc().startOf('day').add(1, 'second');
        startDate = startDate ?
            moment(startDate).utc().startOf('day') :
            moment(endDate).utc().subtract(1, 'day');
    }

    return ['' + startDate.toISOString() + '/' + endDate.toISOString()];
}

/**
 * [findGranularityFromDays convert granularity from string to druid granularity.]
 * @param  {string} duration [the string duration]
 * @return {string|object}   [the druid granularity.]
 */
function findGranularityFromDays(duration, override) {
    var granularity = 'day';
    if (override) {
        granularity = override;
    } else {
        switch (duration) {
            case 'quarter':
                granularity = {};
                granularity.type = 'period';
                granularity.period = 'P1W';
                break;
            case 'year':
                granularity = {};
                granularity.type = 'period';
                granularity.period = 'P1M';
                break;
            default:
                granularity = 'day';
                break;
        }
    }

    return granularity;
}

function getAverageDivisor(duration, granularity) {
    var divisor = 1;
    switch (duration) {
        case 'quarter':
            divisor = 7;
            break;
        case 'year':
            divisor = 30;
            break;
        case 'custom':
            if (granularity && granularity.type === 'period' && granularity.period === "P1M") {
                divisor = 30;
            }
            if (granularity && granularity.type === 'period' && granularity.period === "P1W") {
                divisor = 7;
            }
            break;
    }
    return divisor;
}


function findInterval(duration, userBaseTimeString) {
    //!ToDo convert to UTC
    var startTime,
        dataEndMoment = moment(userBaseTimeString).utc(),
        endTime = dataEndMoment.add(1, 'second');

    switch (duration) {
        case 'week':
            startTime = moment(endTime).utc().subtract(6, 'days').startOf('day');
            break;

        case 'month':
            startTime = moment(endTime).utc().subtract(29, 'days').startOf('day');
            break;

        case 'quarter':
            endTime = (dataEndMoment.isoWeekday() === 7) ?
                dataEndMoment.endOf('isoWeek').subtract(1, 'second') :
                dataEndMoment.startOf('isoWeek').subtract(1, 'second');
            startTime = moment(endTime).utc().subtract(11, 'week').startOf('isoWeek');
            break;

        case 'year':
            endTime = (dataEndMoment.date() === dataEndMoment.daysInMonth()) ?
                dataEndMoment.endOf('month').subtract(1, 'second') :
                dataEndMoment.startOf('month').subtract(1, 'second');

            startTime = moment(endTime).utc().startOf('month').subtract(11, 'month');
            break;

        case 'thisMonth':
            startTime = moment(endTime).utc().startOf('month');
            break;

        default:
            startTime = moment(endTime).utc().subtract(1, 'day');
            break;
    }

    return ['' + startTime.toISOString() + '/' + endTime.toISOString()];
}

function generateAllMinorIntervals(selectedInterval, pointsResolution) {
    var retVal = [],
        j,
        singleRangeWidth,
        min = selectedInterval.min,
        max = selectedInterval.max,
        pointResolutionMaj = pointsResolution.MAJOR,
        pointResolutionMin = pointsResolution.MINOR;

    if (max === 0) {
        retVal = [];
    } else if (max - min === 0) {
        retVal = [
            [min, max]
        ];
    } else if (max - min <= pointResolutionMin * pointResolutionMaj) {
        _.forEach(_.range(min, max + 1), function(value) {
            retVal.push([value, value]);
        });
    } else {
        singleRangeWidth = Math.ceil((max - min) / (pointResolutionMaj * pointResolutionMin));
        for (j = min; j <= max; j = j + singleRangeWidth) {
            if (j + singleRangeWidth >= max) {
                retVal.push([j, max]);
                break;
            } else {
                retVal.push([j, j + singleRangeWidth]);
            }
        }
    }

    return retVal;
}
/**
 * [generateGETQueryString generate the query param string]
 * @param  {string} queryKey   [the key for the query]
 * @param  {array} paramsList [list of values for the queryString]
 * @return {string}            [THe GET query String]
 */
function generateGETQueryString(queryKey, paramsList) {
    var retQueryParam = [];
    _.forEach(paramsList, function(param) {
        retQueryParam.push(queryKey + '=' + param);
    });
    return retQueryParam.join('&');
}

/**
 * [zeroFillEmptyBuckets description]
 * @param  {string} baseTime        [the time of the last sync i.e. the last timestamp in the druid db segments]
 * @param  {string} durationType        [the durationType selected on the UI]
 * @param  {object} inputResponseObject [The response of the timeseries query form the API]
 * @return {undefined}
 */
function zeroFillEmptyBuckets(baseTime, durationType, responseObjectArray, fields, customDurationContext) {

    var interval,
        allTimestamps,
        granularity;

    if (durationType === 'custom') {
        interval = customDurationContext.interval;
        granularity = customDurationContext.granularity; //findCustomGranularity(durationType, durationObj);
        allTimestamps = findAllTimestamps(interval, durationType, granularity);
    } else {
        interval = findInterval(durationType, baseTime)[0];
        allTimestamps = findAllTimestamps(interval, durationType);
    }


    var emptySingleTimestampObject;

    _.forEach(allTimestamps, function(timestamp, index) {
        if (!_.find(responseObjectArray, function(singleResponseObj) {
                return moment(singleResponseObj.timestamp).isSame(timestamp);
            })) {
            emptySingleTimestampObject = createEmptyTimestampObject(fields);
            emptySingleTimestampObject.timestamp = timestamp;
            responseObjectArray.splice(index, 0, emptySingleTimestampObject);
        }
    });

}


function createEmptyTimestampObject(fields) {
    var emptyTimestampObj = {
        timestamp: null,
        result: {}
    };
    _.forEach(fields, function(field) {
        emptyTimestampObj.result[field] = null;
    });
    return emptyTimestampObj;
}


function findAllTimestamps(interval, duration, granularity) {
    var startTime = moment(interval.split('/')[0]).utc();
    var endTime = moment(interval.split('/')[1]).utc();
    var returnTimestampsArray = [];
    switch (duration) {
        case 'week':
            returnTimestampsArray = findAllTimestampsInInterval(startTime, endTime, 'days');
            break;
        case 'month':
            returnTimestampsArray = findAllTimestampsInInterval(startTime, endTime, 'days');
            break;
        case 'quarter':
            returnTimestampsArray = findAllTimestampsInInterval(startTime, endTime, 'weeks');
            break;
        case 'year':
            returnTimestampsArray = findAllTimestampsInInterval(startTime, endTime, 'months');
            break;
        case 'thisMonth':
            returnTimestampsArray = findAllTimestampsInInterval(startTime, endTime, 'days');
            break;
        case 'custom':
            if (granularity && granularity.type === 'period' && granularity.period === 'P1W') {
                returnTimestampsArray = findAllTimestampsInInterval(startTime, endTime, 'weeks');
            } else if (granularity && granularity.type === 'period' && granularity.period === 'P1M') {
                returnTimestampsArray = findAllTimestampsInInterval(startTime, endTime, 'months');
            } else {
                returnTimestampsArray = findAllTimestampsInInterval(startTime, endTime, 'days');
            }
            break;
    }
    return returnTimestampsArray;
}

function findAllTimestampsInInterval(startTime, endTime, granularity) {
    var returnTimestampsArray = [],
        currentTime;
    for (currentTime = startTime; moment(currentTime).isBefore(endTime); currentTime = moment(currentTime).add(1, granularity)) {
        returnTimestampsArray.push(currentTime.toISOString());
    }
    return returnTimestampsArray;
}